export const Pokedex: import('../../../sim/dex-species').ModdedSpeciesDataTable = {
	krokorok: {
		inherit: true,
		name: "Krokorok",
		types: ["Ground", "Dark"],
		baseStats: { hp: 80, atk: 122, def: 72, spa: 65, spd: 80, spe: 75 },
		abilities: { 0: "Sand Rush", H: "Vessel of Sigma" },
	},
	qwilfishhisui: {
		inherit: true,
		name: "Qwilfish-Hisui",
		types: ["Poison", "Dark"],
		baseStats: { hp: 75, atk: 105, def: 85, spa: 85, spd: 80, spe: 75 },
		abilities: { 0: "Levitate", H: "Regenerator" },
	},
	snivy: {
		inherit: true,
		name: "Snivy",
		types: ["Grass", "Fighting"],
		baseStats: { hp: 75, atk: 65, def: 85, spa: 115, spd: 90, spe: 90 },
		abilities: { 0: "Flower Veil" },
	},
	dragonair: {
		inherit: true,
		name: "Dragonair",
		types: ["Dragon", "Fairy"],
		baseStats: { hp: 80, atk: 40, def: 110, spa: 95, spd: 75, spe: 91 },
		abilities: { 0: "Dry Skin", H: "Cloud Nine" },
		otherFormes: ["Dragonair-Mega"],
		formeOrder: ["Dragonair", "Dragonair-Mega"],
	},
	wimpod: {
		inherit: true,
		name: "Wimpod",
		types: ["Bug", "Fire"],
		baseStats: { hp: 72, atk: 60, def: 75, spa: 90, spd: 63, spe: 135 },
		abilities: { 0: "Overcoat", H: "Tactical Retreat" },
	},
	toxel: {
		inherit: true,
		otherFormes: ["Toxel-Hisui"],
		formeOrder: ["Toxel", "Toxel-Hisui"],
	},
	toxelhisui: {
		num: 848,
		name: "Toxel-Hisui",
		baseSpecies: "Toxel",
		forme: "Hisui",
		types: ["Fighting"],
		baseStats: { hp: 80, atk: 70, def: 50, spa: 55, spd: 170, spe: 70 },
		abilities: { 0: "Forbidden Juice", 1: "Cud Chew", H: "Battle Armor" },
		weightkg: 11,
		eggGroups: ["Undiscovered"],
	},
	tadbulb: {
		inherit: true,
		name: "Tadbulb",
		types: ["Water", "Electric"],
		baseStats: { hp: 80, atk: 34, def: 86, spa: 93, spd: 97, spe: 61 },
		abilities: { 0: "Static", H: "Regenerator" },
	},
	pikipek: {
		inherit: true,
		name: "Pikipek",
		types: ["Flying", "Fairy"],
		baseStats: { hp: 100, atk: 80, def: 130, spa: 40, spd: 70, spe: 80 },
		abilities: { 0: "Typhoon", 1: "Big Pecks", H: "Synchronize" },
	},
	chingling: {
		inherit: true,
		name: "Chingling",
		types: ["Psychic", "Ghost"],
		baseStats: { hp: 110, atk: 30, def: 96, spa: 80, spd: 71, spe: 72 },
		abilities: { 0: "Protective Aura", H: "Telepathy" },
	},
	baltoy: {
		inherit: true,
		otherFormes: ["Baltoy-Gear Rider", "Baltoy-Water Rider"],
		formeOrder: ["Baltoy", "Baltoy-Gear Rider", "Baltoy-Water Rider"],
	},
	baltoygearrider: {
		num: 343,
		name: "Baltoy-Gear Rider",
		baseSpecies: "Baltoy",
		forme: "Gear Rider",
		types: ["Ground", "Steel"],
		baseStats: { hp: 60, atk: 100, def: 115, spa: 90, spd: 105, spe: 70 },
		abilities: { 0: "As One (Klang)" },
		weightkg: 72.5,
		eggGroups: ["Undiscovered"],
	},
	baltoywaterrider: {
		num: 343,
		name: "Baltoy-Water Rider",
		baseSpecies: "Baltoy",
		forme: "Water Rider",
		types: ["Ground", "Water"],
		baseStats: { hp: 55, atk: 85, def: 115, spa: 115, spd: 65, spe: 105 },
		abilities: { 0: "As One (Seadra)" },
		weightkg: 46.5,
		eggGroups: ["Undiscovered"],
	},
	charmander: {
		inherit: true,
		name: "Charmander",
		types: ["Fire"],
		baseStats: { hp: 60, atk: 90, def: 80, spa: 80, spd: 80, spe: 120 },
		abilities: { 0: "Rain Curse" },
	},
	nymble: {
		inherit: true,
		name: "Nymble",
		types: ["Bug", "Steel"],
		baseStats: { hp: 76, atk: 112, def: 90, spa: 62, spd: 80, spe: 95 },
		abilities: { 0: "Swarm", H: "Swift Swim" },
	},
	vanillite: {
		inherit: true,
		name: "Vanillite",
		types: ["Ice"],
		baseStats: { hp: 80, atk: 40, def: 85, spa: 90, spd: 70, spe: 125 },
		abilities: { 0: "Spicy Cream" },
		otherFormes: ["Vanillite-Melted"],
		formeOrder: ["Vanillite", "Vanillite-Melted"],
	},
	vanillitemelted: {
		num: 582,
		name: "Vanillite-Melted",
		baseSpecies: "Vanillite",
		forme: "Melted",
		types: ["Ice", "Fire"],
		baseStats: { hp: 80, atk: 30, def: 70, spa: 125, spd: 90, spe: 95 },
		abilities: { 0: "Spicy Cream" },
		weightkg: 5.7,
		eggGroups: ["Mineral"],
		requiredAbility: "Spicy Cream",
		battleOnly: "Vanillite",
	},
	spheal: {
		inherit: true,
		name: "Spheal",
		types: ["Water", "Ice"],
		baseStats: { hp: 100, atk: 40, def: 85, spa: 110, spd: 70, spe: 85 },
		abilities: { 0: "Pyromorphosis" },
	},
	anorith: {
		inherit: true,
		name: "Anorith",
		types: ["Rock", "Bug"],
		baseStats: { hp: 80, atk: 70, def: 130, spa: 20, spd: 90, spe: 90 },
		abilities: { 0: "LAST CALL" },
	},
	ditto: {
		inherit: true,
		name: "Ditto",
		types: ["Normal"],
		baseStats: { hp: 48, atk: 118, def: 48, spa: 118, spd: 48, spe: 48 },
		abilities: { 0: "Limber", H: "Narcissus" },
	},
	jigglypuff: {
		inherit: true,
		name: "Jigglypuff",
		types: ["Normal", "Fairy"],
		baseStats: { hp: 90, atk: 90, def: 90, spa: 90, spd: 90, spe: 90 },
		abilities: { 0: "Magic Bag" },
	},
	bronzor: {
		inherit: true,
		name: "Bronzor",
		types: ["Steel", "Psychic"],
		baseStats: { hp: 64, atk: 84, def: 116, spa: 44, spd: 100, spe: 65 },
		abilities: { 0: "Iron Barbs", H: "Anticipation" },
	},
	wiglett: {
		inherit: true,
		name: "Wiglett",
		types: ["Poison", "Grass"],
		baseStats: { hp: 70, atk: 130, def: 65, spa: 60, spd: 120, spe: 70 },
		abilities: { 0: "Poison Touch", H: "Grassy Surge" },
	},
	gible: {
		inherit: true,
		name: "Gible",
		types: ["Ground", "Dragon"],
		baseStats: { hp: 80, atk: 95, def: 80, spa: 105, spd: 84, spe: 60 },
		abilities: { 0: "Rough Skin", 1: "Sand Veil", H: "Perseverance" },
	},
	vulpix: {
		inherit: true,
		name: "Vulpix",
		types: ["Fire"],
		baseStats: { hp: 100, atk: 60, def: 65, spa: 60, spd: 65, spe: 200 },
		abilities: { 0: "Perseverance" },
	},
	shuppet: {
		inherit: true,
		name: "Shuppet",
		types: ["Ghost"],
		baseStats: { hp: 70, atk: 85, def: 110, spa: 60, spd: 85, spe: 45 },
		abilities: { 0: "Phantom Chute", H: "Levitate" },
	},
	golett: {
		inherit: true,
		name: "Golett",
		types: ["Ground", "Ghost"],
		baseStats: { hp: 60, atk: 70, def: 90, spa: 110, spd: 70, spe: 65 },
		abilities: { 0: "Unburden" },
	},
	elgyem: {
		inherit: true,
		name: "Elgyem",
		types: ["Psychic"],
		baseStats: { hp: 90, atk: 57, def: 72, spa: 80, spd: 135, spe: 80 },
		abilities: { 0: "Pure Power", H: "Levitate" },
	},
	farfetchd: {
		inherit: true,
		types: ["Flying"],
		baseStats: { hp: 112, atk: 97, def: 80, spa: 60, spd: 68, spe: 110 },
		abilities: { 0: "Masquerade" },
	},
	amaura: {
		inherit: true,
		name: "Amaura",
		types: ["Ice", "Rock"],
		baseStats: { hp: 140, atk: 30, def: 60, spa: 120, spd: 70, spe: 80 },
		abilities: { 0: "Reckless", H: "Snow Warning" },
		otherFormes: ["Amaura-Mega"],
		formeOrder: ["Amaura", "Amaura-Mega"],
	},
	wailmer: {
		inherit: true,
		name: "Wailmer",
		types: ["Water"],
		baseStats: { hp: 130, atk: 60, def: 70, spa: 80, spd: 85, spe: 60 },
		abilities: { 0: "Poison Heal", 1: "Air Lock", H: "Debilitate" },
	},
	pikachu: {
		inherit: true,
		name: "Pikachu",
		types: ["Electric", "Steel"],
		baseStats: { hp: 90, atk: 110, def: 80, spa: 110, spd: 60, spe: 120 },
		abilities: { 0: "Metallize", H: "Regenerator" },
		otherFormes: ["Pikachu-Mega"],
		formeOrder: ["Pikachu", "Pikachu-Mega"],
	},
	morelull: {
		inherit: true,
		name: "Morelull",
		types: ["Grass", "Fairy"],
		baseStats: { hp: 80, atk: 5, def: 90, spa: 90, spd: 90, spe: 30 },
		abilities: { 0: "Malicious Roots", H: "Grass Pelt" },
	},

	// Slate 2
	amauramega: {
		num: 698,
		name: "Amaura-Mega",
		baseSpecies: "Amaura",
		forme: "Mega",
		types: ["Ice", "Rock"],
		baseStats: { hp: 140, atk: 50, def: 90, spa: 130, spd: 90, spe: 100 },
		abilities: { 0: "Magic Guard" },
		weightkg: 25.2,
		eggGroups: ["Monster"],
		requiredItem: "Amaurite",
	},
	pikachumega: {
		num: 25,
		name: "Pikachu-Mega",
		baseSpecies: "Pikachu",
		forme: "Mega",
		types: ["Electric", "Steel"],
		baseStats: { hp: 90, atk: 125, def: 100, spa: 125, spd: 100, spe: 130 },
		abilities: { 0: "Good as Gold" },
		weightkg: 6,
		eggGroups: ["Field", "Fairy"],
		requiredItem: "Super Pikachu Mega Stone",
	},
	dragonairmega: {
		num: 148,
		name: "Dragonair-Mega",
		baseSpecies: "Dragonair",
		forme: "Mega",
		types: ["Fairy"],
		baseStats: { hp: 80, atk: 50, def: 120, spa: 105, spd: 105, spe: 131 },
		abilities: { 0: "Misty Surge" },
		weightkg: 16.5,
		eggGroups: ["Water 1", "Dragon"],
		requiredItem: "Dragonairite",
	},
	houndour: {
		inherit: true,
		name: "Houndour",
		types: ["Fire", "Dark"],
		baseStats: { hp: 80, atk: 80, def: 105, spa: 60, spd: 80, spe: 90 },
		abilities: { 0: "Flash Fire", H: "Unnerve" },
	},
	koffing: {
		inherit: true,
		otherFormes: ["Koffing-Hoenn"],
		formeOrder: ["Koffing", "Koffing-Hoenn"],
	},
	koffinghoenn: {
		name: "Koffing-Hoenn",
		types: ["Poison", "Water"],
		baseStats: { hp: 70, atk: 30, def: 100, spa: 95, spd: 75, spe: 80 },
		abilities: { 0: "Neutralizing Gas", H: "Levitate" },
		num: 109,
		weightkg: 1,
		eggGroups: ["Amorphous"],
	},
	tandemaus: {
		inherit: true,
		types: ["Normal"],
		baseStats: { hp: 70, atk: 75, def: 70, spa: 85, spd: 70, spe: 100 },
		abilities: { 0: "Mitosis" },
	},
	hakamoo: {
		inherit: true,
		name: "Hakamo-o",
		types: ["Dragon", "Fighting"],
		baseStats: { hp: 80, atk: 120, def: 90, spa: 100, spd: 100, spe: 85 },
		abilities: { 0: "Multiscale", H: "Bulletproof" },
	},
	kartana: {
		inherit: true,
		name: "Kartana",
		types: ["Grass"],
		baseStats: { hp: 83, atk: 113, def: 139, spa: 67, spd: 41, spe: 97 },
		abilities: { 0: "Flower Veil", H: "Supreme Overlord" },
	},
	ledyba: {
		inherit: true,
		name: "Ledyba",
		types: ["Bug", "Flying"],
		baseStats: { hp: 60, atk: 30, def: 100, spa: 110, spd: 80, spe: 90 },
		abilities: { 0: "Swarm", 1: "Early Bird", H: "Flash Fire" },
	},
	wooperpaldea: {
		inherit: true,
		name: "Wooper-Paldea",
		types: ["Poison", "Ground"],
		baseStats: { hp: 130, atk: 90, def: 90, spa: 60, spd: 60, spe: 30 },
		abilities: { 0: "Water Absorb", 1: "Honey Gather", H: "Unaware" },
	},
	hoothoot: {
		inherit: true,
		name: "Hoothoot",
		types: ["Normal", "Flying"],
		baseStats: { hp: 80, atk: 30, def: 76, spa: 100, spd: 86, spe: 95 },
		abilities: { 0: "Hoothoot Ability" },
	},
	raboot: {
		inherit: true,
		otherFormes: ["Raboot-Sinnoh"],
		formeOrder: ["Raboot", "Raboot-Sinnoh"],
	},
	rabootsinnoh: {
		num: 814,
		name: "Raboot-Sinnoh",
		baseSpecies: "Raboot",
		forme: "Sinnoh",
		types: ["Ice", "Dragon"],
		baseStats: { hp: 70, atk: 75, def: 90, spa: 60, spd: 80, spe: 133 },
		abilities: { 0: "Heatproof", H: "Alpinist" },
		weightkg: 9,
		eggGroups: ["Field", "Human-Like"],
	},
	honedge: {
		inherit: true,
		name: "Honedge",
		types: ["Steel", "Ghost"],
		baseStats: { hp: 86, atk: 115, def: 100, spa: 60, spd: 70, spe: 80 },
		abilities: { 0: "Justified", H: "Slush Rush" },
	},
	roselia: {
		inherit: true,
		name: "Roselia",
		types: ["Grass", "Poison"],
		baseStats: { hp: 70, atk: 65, def: 110, spa: 95, spd: 80, spe: 80 },
		abilities: { 0: "Poison Puppeteer", H: "Poison Point" },
	},
	skiploom: {
		inherit: true,
		name: "Skiploom",
		types: ["Flying"],
		baseStats: { hp: 120, atk: 30, def: 80, spa: 90, spd: 70, spe: 130 },
		abilities: { 0: "Water Absorb", 1: "Soothing Presence", H: "Infiltrator" },
	},
	spritzee: {
		inherit: true,
		name: "Spritzee",
		types: ["Fairy", "Fighting"],
		baseStats: { hp: 70, atk: 85, def: 75, spa: 100, spd: 67, spe: 120 },
		abilities: { 0: "Fairy Aura" },
	},
	helioptile: {
		inherit: true,
		name: "Helioptile",
		types: ["Electric", "Rock"],
		baseStats: { hp: 100, atk: 42, def: 80, spa: 80, spd: 94, spe: 160 },
		abilities: { 0: "Dry Skin", H: "Seismic Sensor" },
	},
	piplup: {
		inherit: true,
		name: "Piplup",
		types: ["Water", "Steel"],
		baseStats: { hp: 90, atk: 40, def: 80, spa: 150, spd: 80, spe: 40 },
		abilities: { 0: "Mold Breaker" },
	},
};
